exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timesheet-view .grand-total {\n  max-width: 46rem;\n  margin: 0 auto 3rem;\n  padding-left: 4rem;\n  text-align: right;\n}\n\n", ""]);

// exports
